export default __webpack_public_path__ + "static/media/01_KYEC.f3c614f3.png";